"use client";

import React, { useEffect, useRef, useState } from "react";
import { Heart } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const caregivers = [{
  name: "Emily Carter",
  role: "Certified Caregiver",
  bio: "Emily has over 10 years of experience in senior care, providing compassionate support and companionship.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/emily_carter_portrait.png"
}, {
  name: "Michael Lee",
  role: "Home Manager",
  bio: "Michael oversees daily operations ensuring personalized and high-quality care for all residents.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/michael_lee_portrait.png"
}];
export default function MeetTheCaregivers() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="meet-the-caregivers" className="py-24 md:py-32 bg-background overflow-hidden">
      
    </section>;
}